__turbopack_context__.v({
  "filters": "R3bGDW_filters",
  "job": "R3bGDW_job",
  "job-list": "R3bGDW_job-list",
  "placeholder": "R3bGDW_placeholder",
  "section": "R3bGDW_section",
  "select": "R3bGDW_select",
});
